import ValidationType from '../ValidationType';
import { numberIsGreaterThan, numbersAreEqual } from "../../util";

class GreaterThanField extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
        const current = fieldResponse.currentValue;
        const compare = targetFieldResponse.currentValue;
        if (!numberIsGreaterThan(current, compare) || numbersAreEqual(current, compare)) {
          errors.push(this.createValidationError({
            fieldResponse,
            key: 'ERROR_GREATER_THAN_SPECIFIED_FIELD',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be greater than '${targetFieldResponse.currentValue}'`,
          }));
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default GreaterThanField;

